<template>
  <h1>{{ $t('plants.configuration.heavy_mobile_equipment.nav') }}</h1>
</template>
<script setup></script>
